<div ngPreserveWhitespaces class="group-name" layout layout-align-items-center margin-bottom-small>
  @if (selectable()) {
  <rt-checkbox
    [indeterminateState]="partiallySelected"
    [checked]="allSelected"
    (valueChange)="selectedChange.emit(!!$event)"
  />
  } @if (symbol(); as symbol) {
  <rt-symbol [symbol]="symbol" margin-right-small-x />
  }
  <rt-heading variant="heading large text-color" [textWrap]="true"> {{ name() }} </rt-heading>
  <rt-badge color="counter-default" [text]="counter()" margin-left-small-x />
  <rt-icon
    colorToken="colorIconLowDefault"
    [class.active]="state() === 'normal'"
    margin-left-small-xx
    name="keyboard-arrow-down"
  />
</div>
@if (state() !== 'normal' && withDivider()) {
<rt-divider />
}
